module.exports = __webpack_public_path__ + "img/store.21f6abdb.png";